module.exports = __webpack_public_path__ + "static/media/mazen-games-backgroun.21681894.png";